export default function SubmitButton(props) {
    return <button type="submit">{props.buttonText}</button>;
}
